import { createFileRoute } from '@tanstack/react-router';

import { ProductDetail } from '@/features/products/ProductDetail';

export const Route = createFileRoute('/_authenticated/products/$productId')({
  component: function ProductDetailPage() {
    const { productId } = Route.useParams();
    return <ProductDetail productId={productId} />;
  },
});
